export default "__VITE_ASSET__68cf6736__"